import React from 'react'

import {
  Layout,
  Header,
  Intro,
  SectionTitle,
  ItemTitle,
  SmallTitle,
} from '../../../../components'

import createBug from '../../../../images/CreateBugTask.png'
import detail from '../../../../images/BeDetailed.png'
import featRequest from '../../../../images/FeatureRequest.png'
import join from '../../../../images/JoinCard.png'
import featdeet from '../../../../images/FeatDetail.png'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            One of the best ways to ensure that Currency is working for you is
            to contribute back to the system. Currency welcomes all feedback and
            contributions that meet our brand and quality standards to create
            the best experience for our users and customers.
          </p>
        </Intro>
        <SectionTitle>Bug Reporting and Fixes</SectionTitle>
        <p>
          Currency is committed to maintaining quality and consistency
          throughout our assets. If you encounter a problem, let us know in any
          of the following ways:
        </p>
        <ol>
          <li>Report the issue in our #currency-bugs Slack channel</li>
          <li>Bring up the issue during a Currency/Design sync</li>
          <li>
            If you're comfortable, follow the steps below to report the bug
            directly onto our{' '}
            <a
              href="https://trello.com/b/66tAfvHX/currency-bug-reporter"
              target="_blank"
              rel="noreferrer"
              className="link"
            >
              bug board
            </a>{' '}
            in Trello (accessible on-network only)
          </li>
        </ol>
        <div class="c-notification--inline-info">
          <div class="c-notification__icon">
            <i class="icon icon--info"></i>
          </div>
          <div class="c-notification__content">
            For tracking purposes, all bugs will end up on the Trello board
            regardless of ingress point
          </div>
        </div>
        <ItemTitle>Reporting Defects Using the Bug Board</ItemTitle>
        <SmallTitle>Create a bug task</SmallTitle>

        {/* <img alt="Card templates" src={templates} width="25%" /> */}
        <p>
          Start in the 'Bug Reported' list. Using the 'Create from Template'
          icon in the bottom-right corner of the list to create the task will
          allow you to categorize the bug by type (design or code), brand and
          code base, if applicable. In turn, this helps us allocate resources to
          ensure the defect is addressed as quickly as possible.
        </p>
        <img
          className="u-pull--center"
          alt="Create bug task"
          src={createBug}
          width="35%"
        />
        <SmallTitle>Be detailed</SmallTitle>
        <p>
          In the card description, give as much relevant information up front as
          you can. This includes steps to reproduce, screenshots, what the
          expected behavior should be, urgency and impact, etc.
        </p>
        <img
          className="u-pull--center"
          alt="Give as much detail in the description as possible"
          src={detail}
          width="50%"
        />
        <SmallTitle>Join the Card</SmallTitle>
        <p>
          Becoming a member of the card will keep you up to date as it moves
          through the various Currency boards. Feel free to add any other
          members who may want to stay in the loop.
        </p>
        <img
          className="u-pull--center"
          alt="Join the card"
          src={join}
          width="60%"
        />
        <SmallTitle>Chat with us</SmallTitle>
        <p>
          Sometimes it will be necessary for us to gather more information
          regarding your bug report before we can diagnose it, so expect to hear
          from the team. We may comment on the card in Trello, chat with you in
          a sync or reach out one-on-one.
        </p>
        <p className="l-margin-top--xxlarge">
          Once a bug is reported, Currency will gather all of the necessary
          information to determine whether it is a unique defect. If it's not in
          fact a defect or if it's a duplicate, it will be moved to the 'Bug
          Rejected' list with reasoning. Otherwise, once diagnosed the bug will
          be moved to the 'Bug Accepted' list and then into our backlog for
          prioritization.
        </p>
        <hr />
        <SectionTitle>Feature Requests</SectionTitle>
        <p>
          Have an idea for something new? Or a reusable asset already built out?
          Currency depends on the involvement of our users, so let us know!
          Similar to bug reporting, you can reach out with feature requests via
          any of the following channels:
        </p>
        <ol>
          <li>Use the #design-systems or any team-specific Slack channel</li>
          <li>Bring up an idea during a Currency/Design sync</li>
          <li>
            If you're comfortable, follow the steps below to request a feature
            directly onto our{' '}
            <a
              href="https://trello.com/b/w7f22Ctc/currency-feature-request"
              className="link"
              target="_blank"
              rel="noreferrer"
            >
              feature request
            </a>{' '}
            board in Trello (accessible on-network only)
          </li>
        </ol>
        <div class="c-notification--inline-info">
          <div class="c-notification__icon">
            <i class="icon icon--info"></i>
          </div>
          <div class="c-notification__content">
            For tracking purposes, all approved feature requests will end up on
            the Trello board regardless of ingress point
          </div>
        </div>
        <ItemTitle>
          Requesting features using the feature request board
        </ItemTitle>
        <SmallTitle>Create a card</SmallTitle>
        <p>
          Start in the 'Feature Request' list. Using the 'Create from Template'
          icon in the bottom-right corner of the list to create the task, create
          a card using the Feature Request template. This template includes a
          checklist that will help Currency decide if the asset is right for the
          design system.
        </p>
        <img
          className="u-pull--center"
          alt="Feature Request creation"
          src={featRequest}
          width="50%"
        />
        <SmallTitle>Be detailed</SmallTitle>
        <p>
          In the card description, tell us the problem this feature solves for
          you, why it needed to be created instead of extending an existing
          asset, and how you might see it applied more broadly.
        </p>
        <img
          className="u-pull--center"
          alt="Feature detail creation"
          src={featdeet}
          width="50%"
        />
        <SmallTitle>Join the card</SmallTitle>
        <p>
          Becoming a member of the card will keep you up to date as it moves
          through the various Currency boards. Feel free to add any other
          members who may want to stay in the loop.
        </p>
        <SmallTitle>Chat with us</SmallTitle>
        <p>
          Generally, feature requests require more conversation with the
          Currency team than bug fixes to ensure that the proposed solution is
          scalable, reusable and meets our brand requirements. Feature requests
          will also be brought up at team syncs to gauge how these proposed
          assets can be leveraged across teams.
        </p>
        <p className="l-margin-top--xxlarge">
          Once a feature request is approved, it will move into the Currency
          backlog for prioritization.
        </p>
      </Layout>
    </>
  )
}
